var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFermentadora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.798829 0H15.2586V18.9899H0.798829C0.364023 18.9899 0 18.636 0 18.1911V0.798829C0 0.364023 0.353912 0 0.798829 0ZM4.69186 3.41778V0.596594H10.5466V3.41778H4.69186ZM1.38531 17.6855C1.23363 17.6855 1.12241 17.5641 1.12241 17.4226V4.2975C1.12241 4.14582 1.24375 4.01437 1.38531 4.01437H13.8632C14.0149 4.01437 14.1362 4.13571 14.1362 4.2975V17.4226C14.1362 17.5641 14.0048 17.6855 13.8632 17.6855H1.38531ZM1.70889 17.0889V4.61096H13.5295V17.0889H1.70889Z",
    fill: "#1E4882"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8457 0H17.4332C17.8681 0 18.2321 0.353912 18.2321 0.798829V18.2012C18.2321 18.636 17.8782 19 17.4332 19H15.8457V0ZM16.7355 6.43108H17.3321V12.5487H16.7355V6.43108Z",
    fill: "#1E4882"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFermentadora);
export default __webpack_public_path__ + "static/media/fermentadora.53e1c9521c2c3c12ca4a0da387775a3f.svg";
export { ForwardRef as ReactComponent };